export default {
    業務の種類: '業務の種類',
    起算日: '起算日',
    標準限度時間: '標準限度時間',
    法定休日数: '法定休日数',
    特別条項: '特別条項',
    発動回数: '発動回数'
};
